import { AuthenticatedResolver } from './AuthenticatedResolver';
import { VersionsResolver } from './VersionsResolver';

export class ResolverProviderFactory {
	addProviderTypes(dependencies: any[]) {
		dependencies.push({ provide: AuthenticatedResolver, useClass: AuthenticatedResolver });
		dependencies.push({ provide: VersionsResolver, useClass: VersionsResolver });
	}
}
